import { types } from 'mobx-state-tree'
import { CountryMarkModel } from './CountryMarkModel'

export const WorkCountriesModel = types.model('WorkCountriesModel', {
  id: types.number,
  name: types.string,
  countryMarks: types.array(types.maybeNull(CountryMarkModel)),
})
